(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-carousel"] && !Shopify.designMode) return;
  try {
    
  class BannerCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-bc-track]');
      this.slides = Array.from(this.querySelectorAll('[data-bc-slide]'));
      this.prevBtn = this.querySelector('[data-bc-prev]');
      this.nextBtn = this.querySelector('[data-bc-next]');
      this.playBtn = this.querySelector('[data-bc-play]');
      this.dots = Array.from(this.querySelectorAll('[data-bc-dot]'));
      this.status = this.querySelector('[data-bc-status]');

      if (!this.track || this.slides.length === 0) return;

      this.loop = this.dataset.loop === 'true';
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.currentIndex = 0;
      this.autoplayTimer = null;
      this.isPlaying = false;
      this._listeners = [];
      this._scrollFrame = null;
      this._scrollEndTimer = null;

      this.#bindEvents();
      this.#enableDragScroll();
      this.#updateCurrentIndexFromScroll();
      this.#updateControls();

      if (this.autoplayEnabled && !this.reducedMotion && this.slides.length > 1) {
        this.#startAutoplay();
      } else if (this.playBtn) {
        this.playBtn.hidden = true;
      }
    }

    disconnectedCallback() {
      this.#stopAutoplay();
      if (this._scrollFrame) window.cancelAnimationFrame(this._scrollFrame);
      if (this._scrollEndTimer) window.clearTimeout(this._scrollEndTimer);

      for (const { target, event, handler, options } of this._listeners || []) {
        target.removeEventListener(event, handler, options);
      }
      this._listeners = [];
    }

    #bindEvents() {
      this.#addListener(this.prevBtn, 'click', () => this.#go(-1, true));
      this.#addListener(this.nextBtn, 'click', () => this.#go(1, true));
      this.#addListener(this.playBtn, 'click', () => this.#toggleAutoplay());

      for (const dot of this.dots) {
        this.#addListener(dot, 'click', () => {
          const index = parseInt(dot.dataset.bcDot, 10);
          this.#scrollToIndex(index, true);
        });
      }

      this.#addListener(this, 'mouseenter', () => this.#pauseAutoplay());
      this.#addListener(this, 'mouseleave', () => this.#resumeAutoplay());
      this.#addListener(this, 'focusin', () => this.#pauseAutoplay());
      this.#addListener(this, 'focusout', () => this.#resumeAutoplay());
      this.#addListener(this.track, 'scroll', () => this.#onScroll(), { passive: true });

      this.#addListener(document, 'visibilitychange', () => {
        if (document.hidden) {
          this.#pauseAutoplay();
        } else {
          this.#resumeAutoplay();
        }
      });
    }

    #addListener(target, event, handler, options) {
      if (!target) return;
      target.addEventListener(event, handler, options);
      this._listeners.push({ target, event, handler, options });
    }

    #enableDragScroll() {
      const track = this.track;
      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;
      const threshold = 5;

      const onPointerDown = (event) => {
        if (event.pointerType === 'touch') {
          this.#pauseAutoplay();
          return;
        }
        if (event.button !== 0) return;
        isDown = true;
        moved = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
      };

      const onPointerMove = (event) => {
        if (!isDown) return;
        const deltaX = event.clientX - startX;

        if (!moved && Math.abs(deltaX) > threshold) {
          moved = true;
          track.classList.add('is-dragging');
          track.style.scrollSnapType = 'none';
          track.setPointerCapture?.(event.pointerId);
          this.#pauseAutoplay();
        }

        if (moved) {
          track.scrollLeft = startScroll - deltaX;
          event.preventDefault();
        }
      };

      const onPointerUp = (event) => {
        if (event.pointerType === 'touch') {
          this.#resumeAutoplay();
          return;
        }
        if (!isDown) return;
        isDown = false;

        if (!moved) return;
        track.classList.remove('is-dragging');
        track.style.scrollSnapType = '';

        if (track.hasPointerCapture?.(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }
        this.#updateCurrentIndexFromScroll();
        this.#resumeAutoplay();
      };

      const onClickCapture = (event) => {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      };

      const onDragStart = (event) => event.preventDefault();

      this.#addListener(track, 'pointerdown', onPointerDown);
      this.#addListener(track, 'pointermove', onPointerMove);
      this.#addListener(track, 'pointerup', onPointerUp);
      this.#addListener(track, 'pointercancel', onPointerUp);
      this.#addListener(track, 'click', onClickCapture, true);
      this.#addListener(track, 'dragstart', onDragStart);
    }

    #onScroll() {
      if (this._scrollFrame) return;
      this._scrollFrame = window.requestAnimationFrame(() => {
        this._scrollFrame = null;
        this.#updateCurrentIndexFromScroll();
      });

      if (this._scrollEndTimer) window.clearTimeout(this._scrollEndTimer);
      this._scrollEndTimer = window.setTimeout(() => {
        this.#updateCurrentIndexFromScroll();
      }, 120);
    }

    #updateCurrentIndexFromScroll() {
      const nextIndex = this.#getClosestSlideIndex();
      if (nextIndex === this.currentIndex) return;

      this.currentIndex = nextIndex;
      this.#updateControls();
    }

    #getClosestSlideIndex() {
      const maxScroll = this.#getMaxScroll();
      const scrollLeft = this.track.scrollLeft;

      if (maxScroll > 0 && maxScroll - scrollLeft <= 1) {
        return this.slides.length - 1;
      }

      let closestIndex = 0;
      let closestDistance = Infinity;

      this.slides.forEach((slide, index) => {
        const distance = Math.abs(this.#getSlideLeft(slide) - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    #getSlideLeft(slide) {
      const maxScroll = this.#getMaxScroll();
      const left = slide.offsetLeft - this.track.offsetLeft;
      return Math.min(Math.max(left, 0), maxScroll);
    }

    #getMaxScroll() {
      return Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
    }

    #isAtEnd() {
      const maxScroll = this.#getMaxScroll();
      return maxScroll <= 1 || maxScroll - this.track.scrollLeft <= 1 || this.currentIndex >= this.slides.length - 1;
    }

    #go(direction, fromUser) {
      let next = this.currentIndex + direction;
      if (next < 0) next = this.loop ? this.slides.length - 1 : 0;
      if (next > this.slides.length - 1) next = this.loop ? 0 : this.slides.length - 1;
      this.#scrollToIndex(next, fromUser);
    }

    #scrollToIndex(index, fromUser) {
      const slide = this.slides[index];
      if (!slide) return;

      this.currentIndex = index;
      this.track.scrollTo({
        left: this.#getSlideLeft(slide),
        behavior: this.reducedMotion ? 'auto' : 'smooth',
      });

      if (fromUser) {
        this.#announce();
      }
      this.#updateControls();
    }

    #updateControls() {
      for (const dot of this.dots) {
        const index = parseInt(dot.dataset.bcDot, 10);
        const active = index === this.currentIndex;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      }

      if (!this.loop) {
        if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.slides.length - 1;
      } else {
        if (this.prevBtn) this.prevBtn.disabled = false;
        if (this.nextBtn) this.nextBtn.disabled = false;
      }
    }

    #announce() {
      if (this.status) {
        this.status.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
      }
    }

    /* ---- Autoplay ---- */
    #startAutoplay() {
      if (!this.autoplayEnabled || this.reducedMotion || this.slides.length <= 1) return;
      this.#clearAutoplayTimer();
      if (!this.loop && this.#isAtEnd()) {
        this.#scrollToIndex(0, false);
      }
      this.isPlaying = true;
      this.#scheduleAutoplay();
      this.#syncPlayBtn();
    }

    #stopAutoplay() {
      this.#clearAutoplayTimer();
      this.isPlaying = false;
      this.#syncPlayBtn();
    }

    #pauseAutoplay() {
      if (this.autoplayEnabled && this.isPlaying) {
        this.#clearAutoplayTimer();
      }
    }

    #resumeAutoplay() {
      if (this.autoplayEnabled && !this.reducedMotion && this.isPlaying && !this.autoplayTimer) {
        this.#scheduleAutoplay();
      }
    }

    #toggleAutoplay() {
      if (this.isPlaying) {
        this.#stopAutoplay();
      } else {
        this.#startAutoplay();
      }
    }

    #scheduleAutoplay() {
      this.#clearAutoplayTimer();
      this.autoplayTimer = window.setTimeout(() => {
        this.autoplayTimer = null;
        if (this.#advanceAutoplay()) {
          this.#scheduleAutoplay();
        }
      }, this.autoplaySpeed);
    }

    #advanceAutoplay() {
      if (document.hidden || this.reducedMotion) return false;

      if (this.#isAtEnd()) {
        if (!this.loop) {
          this.#stopAutoplay();
          return false;
        }
        this.#scrollToIndex(0, false);
        return true;
      }

      this.#scrollToIndex(Math.min(this.currentIndex + 1, this.slides.length - 1), false);
      return true;
    }

    #clearAutoplayTimer() {
      if (!this.autoplayTimer) return;
      window.clearTimeout(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    #syncPlayBtn() {
      if (!this.playBtn) return;
      const pauseIcon = this.playBtn.querySelector('.banner-carousel__icon--pause');
      const playIcon = this.playBtn.querySelector('.banner-carousel__icon--play');
      this.playBtn.setAttribute('aria-pressed', this.isPlaying ? 'false' : 'true');
      if (pauseIcon) pauseIcon.hidden = !this.isPlaying;
      if (playIcon) playIcon.hidden = this.isPlaying;
    }
  }

  if (!customElements.get('banner-carousel')) {
    customElements.define('banner-carousel', BannerCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brw_hero_v1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const playBtn = e.target.closest('.hero-landing__play-btn');
    if (!playBtn) return;

    const wrap = playBtn.closest('.hero-landing__video-wrap');
    const video = wrap?.querySelector('.hero-landing__video');
    if (!video) return;

    video.play().then(() => {
      video.muted = false;
      video.controls = true;
      wrap.classList.add('hero-landing__video-wrap--playing');
    }).catch((err) => {
      console.warn('Video play failed:', err);
    });
  });

  document.addEventListener('pause', (e) => {
    if (!e.target.classList?.contains('hero-landing__video')) return;
    const wrap = e.target.closest('.hero-landing__video-wrap');
    if (wrap) wrap.classList.remove('hero-landing__video-wrap--playing');
  }, true);

  document.addEventListener('playing', (e) => {
    if (!e.target.classList?.contains('hero-landing__video')) return;
    const wrap = e.target.closest('.hero-landing__video-wrap');
    if (wrap) wrap.classList.add('hero-landing__video-wrap--playing');
  }, true);

  } catch(e) { console.error(e); }
})();
})();
